<ion-buttons [ngClass]="{ }">
	<ion-button
		[disabled]="!isNoApiModeEnabled && buttonsStatus === cardButtonsStatus.copyRecord"
		*ngIf="!isRequestPending"
		(click)="copyIn()"
	>
		<ion-icon class="icon-Copy"></ion-icon>
		{{ 'cards.buttons.labels.copyIn' | translate }}
	</ion-button>
	<ion-button *ngIf="!isRequestPending && buttonsStatus === cardButtonsStatus.masterRecord" (click)="checkIn()">
		<ion-icon class="icon-Copy"></ion-icon>
		{{ 'cards.buttons.labels.checkIn' | translate }}
	</ion-button>
	<ion-button *ngIf="!isRequestPending && buttonsStatus === cardButtonsStatus.copyRecord" (click)="checkOut()">
		<ion-icon class="icon-Copy"></ion-icon>
		{{ 'cards.buttons.labels.checkOut' | translate }}
	</ion-button>
	<ion-button (click)="viewReportPreview()">
		<ion-icon name="eye"></ion-icon>
	</ion-button>
	<ion-spinner *ngIf="isRequestPending" name="dots"></ion-spinner>
</ion-buttons>
